import {
  Button,
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import {
  ProductListFilterRootParamList,
  ProductsRootScreenParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ProductListFilterScreen } from "../ProductListFilterScreen";
import { useTranslation } from "../../../../utilities/i18n";
import {
  FilterListRenderContextType,
  GenericFilterListScreen,
} from "../../../../components/GenericFilterListScreen";
import { useGenericFilterListScreen } from "../../../../components/GenericFilterListScreen/hooks";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import { ProductsFilterValues } from "../../types";

export interface ProductListFilterRootScreenProps
  extends StackScreenProps<
    ProductsRootScreenParamList,
    "ProductListFilterRootScreen"
  > {}

export const ProductListFilterRootScreen =
  ({}: ProductListFilterRootScreenProps) => {
    const { t } = useTranslation("product");

    const listFilterContext = useGenericFilterListScreen();

    const { filterState, clearAll } =
      useListFilterContext<ProductsFilterValues>();

    const { activeFiltersCount } = filterState;

    const RootNavigator =
      createStackHeaderNavigator<ProductListFilterRootParamList>();

    return (
      <FilterListRenderContextType.Provider value={listFilterContext}>
        <RootNavigator.Navigator
          screenOptions={{
            title: "",
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Group
            screenOptions={{
              headerShown: true,
              headerLeft: () => <ModalCloseButton type="Close" />,
              headerRight(props) {
                return (
                  <Button
                    label={t("common:clear_filters")}
                    isAction
                    disabled={activeFiltersCount == 0}
                    onPress={clearAll}
                    size="compact"
                  ></Button>
                );
              },
            }}
          >
            <RootNavigator.Screen
              name="ProductListFilterScreen"
              component={ProductListFilterScreen}
            />
          </RootNavigator.Group>
          <RootNavigator.Group
            screenOptions={{
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
          >
            <RootNavigator.Screen
              name="GenericFilterListScreen"
              component={GenericFilterListScreen}
            />
          </RootNavigator.Group>
        </RootNavigator.Navigator>
      </FilterListRenderContextType.Provider>
    );
  };
